import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';

export default function AuthCallback() {
  const { handleAuthRedirect } = useAuth();

  useEffect(() => {
    handleAuthRedirect();
  }, []);

  return (<div className="min-h-screen bg-gray-50 flex items-center justify-center">
  <div className="text-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0049ac] mx-auto"></div>
    <p className="mt-4 text-gray-600">Loading your progress...</p>
  </div>
</div>
); // You can replace this with a loading spinner or message
}
